import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";
import { RestApiService } from "src/app/core/services/rest-api.service";
import { of } from "rxjs";
import * as DemandeAchatListAction from "./demande-achat-list.actions";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class DemandeAchatListEffects {
	constructor(
		private action$: Actions,
		private restApiService: RestApiService,
		private http: HttpClient
	) {}

	loadDemandeAchatList$ = createEffect(() => {
		return this.action$.pipe(
			ofType(DemandeAchatListAction.LoadDemandeAchatList),
			mergeMap(() =>
				this.restApiService.get("demandes", { jwt: "" }).pipe(
					map((demandeAchatList) => {
						return DemandeAchatListAction.LoadDemandeAchatListSuccess({ demandeAchatList: demandeAchatList.data });
					}),
					catchError((error) => of(DemandeAchatListAction.LoadDemandeAchatListFail({ error: error.message })))
				)
			)
		);
	});
}
